import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid gap-6" }
const _hoisted_2 = { class: "grid gap-2" }
const _hoisted_3 = { class: "grid gap-2" }
const _hoisted_4 = { class: "grid gap-2" }
const _hoisted_5 = { class: "grid gap-2" }
const _hoisted_6 = { class: "text-center text-sm text-muted-foreground" }

import InputError from '@/components/InputError.vue';
import TextLink from '@/components/TextLink.vue';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import AuthBase from '@/layouts/AuthLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { LoaderCircle } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route('register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthBase, {
    title: "Create an account",
    description: "Enter your details below to create your account"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), { title: "Register" }),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"]),
        class: "flex flex-col gap-6"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Label), { for: "name" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Name")
              ])),
              _: 1,
              __: [4]
            }),
            _createVNode(_unref(Input), {
              id: "name",
              type: "text",
              required: "",
              autofocus: "",
              tabindex: 1,
              autocomplete: "name",
              modelValue: _unref(form).name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
              placeholder: "Full name"
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.name
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Label), { for: "email" }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Email address")
              ])),
              _: 1,
              __: [5]
            }),
            _createVNode(_unref(Input), {
              id: "email",
              type: "email",
              required: "",
              tabindex: 2,
              autocomplete: "email",
              modelValue: _unref(form).email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).email) = $event)),
              placeholder: "email@example.com"
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.email
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Label), { for: "password" }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Password")
              ])),
              _: 1,
              __: [6]
            }),
            _createVNode(_unref(Input), {
              id: "password",
              type: "password",
              required: "",
              tabindex: 3,
              autocomplete: "new-password",
              modelValue: _unref(form).password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password) = $event)),
              placeholder: "Password"
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.password
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Label), { for: "password_confirmation" }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Confirm password")
              ])),
              _: 1,
              __: [7]
            }),
            _createVNode(_unref(Input), {
              id: "password_confirmation",
              type: "password",
              required: "",
              tabindex: 4,
              autocomplete: "new-password",
              modelValue: _unref(form).password_confirmation,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).password_confirmation) = $event)),
              placeholder: "Confirm password"
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.password_confirmation
            }, null, 8, ["message"])
          ]),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "mt-2 w-full",
            tabindex: "5",
            disabled: _unref(form).processing
          }, {
            default: _withCtx(() => [
              (_unref(form).processing)
                ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                    key: 0,
                    class: "h-4 w-4 animate-spin"
                  }))
                : _createCommentVNode("", true),
              _cache[8] || (_cache[8] = _createTextVNode(" Create account "))
            ]),
            _: 1,
            __: [8]
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createTextVNode(" Already have an account? ")),
          _createVNode(TextLink, {
            href: _ctx.route('login'),
            class: "underline underline-offset-4",
            tabindex: 6
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Log in")
            ])),
            _: 1,
            __: [9]
          }, 8, ["href"])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})